import api from './axios'

/**
 * Form External API Settings service
 * Handles API key management and configuration for external access
 */
export const formApiSettingsApi = {
    /**
     * Get API settings for a form
     */
    getSettings: async (formId) => {
        // axios interceptor already returns response.data, so we return directly
        const response = await api.get(`/forms/${formId}/api-settings`)
        return response
    },

    /**
     * Create or update API settings
     */
    updateSettings: async (formId, settings) => {
        const response = await api.post(`/forms/${formId}/api-settings`, settings)
        return response
    },

    /**
     * Regenerate API key (invalidates old key)
     */
    regenerateKey: async (formId) => {
        const response = await api.post(`/forms/${formId}/api-settings/regenerate`)
        return response
    },

    /**
     * Revoke API access (deletes API key)
     */
    revokeKey: async (formId) => {
        const response = await api.delete(`/forms/${formId}/api-settings`)
        return response
    },

    /**
     * Get API usage statistics
     */
    getStats: async (formId) => {
        const response = await api.get(`/forms/${formId}/api-settings/stats`)
        return response
    }
}

export default formApiSettingsApi

